(() => {
  'use strict';
  const form = document.querySelector('form[data-catalog-product="true"]');
  const mainImage = document.querySelector('#catalog-main-image');
  const thumbs = [...document.querySelectorAll('[data-gallery-src]')];
  const total = document.querySelector('#catalog-total');
  const stickyPrice = document.querySelector('#catalog-sticky-price');
  const quantity = document.querySelector('#catalog-quantity');
  const bundleOffers = [...(form?.querySelectorAll('input[name="catalog-offer"]') || [])];
  const sticky = document.querySelector('#catalog-mobile-buy');
  const refillOptions = [...(form?.querySelectorAll('[data-catalog-refill]') || [])];
  const itemFields = form?.querySelector('[data-catalog-items]');
  let imageIndex = 0;

  const money = value => `CHF ${Number(value).toFixed(2).replace('.00', '.–')}`;
  const clamp = value => Math.min(20, Math.max(1, Number.isFinite(value) ? Math.trunc(value) : 1));

  function showImage(src, alt, index = -1) {
    if (!mainImage || !src) return;
    (window.BasicProductImages ? window.BasicProductImages.setImage(mainImage, src) : (mainImage.removeAttribute('srcset'), mainImage.src = src));
    mainImage.alt = alt;
    imageIndex = index;
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
  }

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(thumb.dataset.gallerySrc, thumb.dataset.galleryAlt || '', index)));
  document.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
    if (!thumbs.length) return;
    const next = (imageIndex < 0 ? 0 : imageIndex) + thumbs.length - 1;
    thumbs[next % thumbs.length].click();
  });
  document.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
    if (!thumbs.length) return;
    thumbs[(imageIndex + 1) % thumbs.length].click();
  });

  if (!form) return;
  if (itemFields) {
    const requestedVariant = new URLSearchParams(location.search).get('variant');
    const option = [...form.querySelectorAll('input[name="id"]')].find(input => input.value === requestedVariant);
    if (option) option.checked = true;
  }

  function updateRefills(variant, count) {
    if (!itemFields || !variant) return 0;
    const prices = refillOptions.filter(option => !option.disabled).map(option => Number(option.dataset.price));
    const samePrice = prices.length > 0 && prices.every(price => Number.isFinite(price) && price === prices[0]);
    const unitPrice = form.querySelector('[data-refills-unit-price]');
    if (unitPrice) {unitPrice.textContent = samePrice ? ` · ${money(prices[0])}` : ''; unitPrice.hidden = !samePrice;}
    refillOptions.forEach(option => {
      const label = option.closest('.catalog-refill-card')?.querySelector('[data-refill-price]');
      if (label) {label.hidden = samePrice; label.textContent = money(option.dataset.price || 0);}
    });
    const fields = document.createDocumentFragment();
    const lines = [{id:variant.value, quantity:count, role:'applicator'}];
    let refillTotal = 0;
    for (const option of refillOptions) {
      const card = option.closest('.catalog-refill-card');
      const input = card?.querySelector('[data-refill-quantity]');
      const selected = option.checked && !option.disabled;
      const amount = clamp(Number(input?.value || 1));
      if (input) input.value = String(amount);
      card?.classList.toggle('is-selected', selected);
      const controls = card?.querySelector('.catalog-refill-quantity');
      if (controls) controls.hidden = !selected;
      if (!selected) continue;
      lines.push({id:option.dataset.id, quantity:amount, role:'refill'});
      refillTotal += Number(option.dataset.price || 0) * amount;
    }
    lines.forEach((line, index) => {
      for (const [name, value] of Object.entries({id:line.id, quantity:line.quantity, 'properties[_basic_item_role]':line.role})) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name.startsWith('properties[') ? `items[${index}][properties][${name.slice(11,-1)}]` : `items[${index}][${name}]`;
        input.value = String(value);
        fields.append(input);
      }
    });
    itemFields.replaceChildren(fields);
    return refillTotal;
  }

  function updateSelection({ preserveGallery = false } = {}) {
    const variant = form.querySelector('input[name="id"]:checked');
    form.querySelectorAll('.catalog-option').forEach(option => option.classList.toggle('is-selected', option.contains(variant)));
    if (variant) {
      form.dataset.productPrice = variant.dataset.price || form.dataset.productPrice;
      form.dataset.productDetail = variant.dataset.title || form.dataset.productDetail;
      if (variant.dataset.image) {
        form.dataset.productImage = variant.dataset.image;
        if (!preserveGallery) showImage(variant.dataset.image, `${form.dataset.productTitle} · ${variant.dataset.title || ''}`, thumbs.findIndex(thumb => thumb.dataset.gallerySrc === variant.dataset.image));
      }
    }
    const count = bundleOffers.length
      ? Number(bundleOffers.find(option => option.checked)?.value || 1)
      : clamp(Number(quantity?.value));
    if (quantity) quantity.value = String(count);
    const price = Number(form.dataset.productPrice);
    if (!Number.isFinite(price) || price < 0) return;
    if (bundleOffers.length) {
      bundleOffers.forEach(option => option.closest('.classik-offer')?.classList.toggle('is-selected', Number(option.value) === count));
      for (const offerCount of [1, 3, 6]) {
        const offerPrice = price * offerCount - (offerCount === 3 ? 3 : offerCount === 6 ? price : 0);
        const priceLabel = form.querySelector(`[data-offer-price="${offerCount}"]`);
        const compareLabel = form.querySelector(`[data-offer-compare="${offerCount}"]`);
        const savingLabel = form.querySelector(`[data-offer-saving="${offerCount}"]`);
        if (priceLabel) priceLabel.textContent = money(offerPrice);
        if (compareLabel) compareLabel.textContent = money(price * offerCount);
        if (savingLabel) savingLabel.textContent = `Économie ${money(price * offerCount - offerPrice)}`;
      }
    }
    const offerTotal = price * count - (bundleOffers.length && count === 3 ? 3 : bundleOffers.length && count === 6 ? price : 0);
    const formatted = money(offerTotal + updateRefills(variant, count));
    if (total) total.textContent = formatted;
    if (stickyPrice) stickyPrice.textContent = formatted;
  }

  form.querySelectorAll('input[name="id"]').forEach(input => input.addEventListener('change', () => updateSelection()));
  bundleOffers.forEach(input => input.addEventListener('change', () => updateSelection()));
  form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {quantity.value = String(clamp(Number(quantity.value) - 1)); updateSelection();});
  form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {quantity.value = String(clamp(Number(quantity.value) + 1)); updateSelection();});
  quantity?.addEventListener('input', () => updateSelection());
  quantity?.addEventListener('change', () => updateSelection());
  refillOptions.forEach(input => input.addEventListener('change', () => updateSelection({preserveGallery:true})));
  form.querySelectorAll('[data-refill-quantity]').forEach(input => {
    input.addEventListener('input', () => updateSelection({preserveGallery:true}));
    input.addEventListener('change', () => updateSelection({preserveGallery:true}));
  });
  form.querySelectorAll('[data-refill-step]').forEach(button => button.addEventListener('click', () => {
    const input = button.closest('.catalog-refill-card')?.querySelector('[data-refill-quantity]');
    if (!input) return;
    input.value = String(clamp(Number(input.value) + Number(button.dataset.refillStep)));
    updateSelection({preserveGallery:true});
  }));
  form.addEventListener('basic-catalog-sync', () => updateSelection({preserveGallery:true}));
  updateSelection({ preserveGallery: !itemFields });

  if (sticky) {
    const visible = value => {
      sticky.classList.toggle('is-visible', value);
      sticky.setAttribute('aria-hidden', value ? 'false' : 'true');
      sticky.inert = !value;
    };
    const observer = new IntersectionObserver(entries => visible(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0), {threshold: 0});
    observer.observe(form);
  }
})();
